import React from "react";
import { createRoot } from "react-dom/client";
import { Route, BrowserRouter, Routes, Navigate } from "react-router-dom";

import Redirect from "./Redirect";

document.body.innerHTML = '<div id="root"></div>';

const root = createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Routes>
      <Route index element={<Redirect />} />
      <Route path="*" element={<Navigate replace to="/" />} />
    </Routes>
  </BrowserRouter>
);
